<template>
  <v-app id="app">
    <router-view />
  </v-app>
</template>

<script setup lang="ts">
import { useTheme } from 'vuetify'
import { useI18n } from 'vue-i18n'
import { ElectionLocale } from '@/types'
import { availableLanguages } from '@/plugins/i18n'
import { themes } from '@/themes'
import { onBeforeMount } from 'vue'

const { locale } = useI18n()
const language = localStorage.getItem('locale') as ElectionLocale
if (language && availableLanguages.includes(language)) {
  locale.value = language
} else {
  const navigatorLocale = navigator.language.split('-')[0]
  if (['de', 'it', 'en'].includes(navigatorLocale)) {
    locale.value = navigatorLocale
  }
}
const theme = useTheme()
//By default, activate the theme set in the .env file
theme.global.name.value = import.meta.env.VITE_THEME

onBeforeMount(() => {
  const params = new URLSearchParams(location.search)
  if (params.has('theme') && Object.keys(themes).includes(params.get('theme') as string)) {
    theme.global.name.value = params.get('theme') as string
  }
})
</script>

<style lang="scss">
@use 'vuetify/styles';
@import "fonts.scss";

body {
  overflow: auto;
}
</style>
